import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DataService} from 'shared/_services/data.service';
import {LoggedUser} from 'app/_interfaces/logged-user';
import {Store} from '@ngrx/store';
import {login} from 'app/_actions/user.actions';
import {selectLoggedUser} from 'app/_selectors/user.selectors';
@Injectable({
	providedIn: 'root'
})
export class UserService {
	// todo deprecate
	loggedUser$: BehaviorSubject<LoggedUser> = new BehaviorSubject(null);
	previousUsers$ = new BehaviorSubject<[string, LoggedUser][]>(null);
	// todo deprecate
	get user(): LoggedUser { return this.loggedUser$.getValue(); }
	set user(s: LoggedUser) {
		if (!s) return;
		this.store.dispatch(login({user: s}));
	}
	constructor(private data: DataService, private store: Store) {
		this.getPreviousUsers();
		// todo replace all calls from get/set user to store calls
		this.store.select(selectLoggedUser).subscribe(user => {
			if (user) this.loggedUser$.next(user);
		});
	}

	getPreviousUsers() {
		const prevData = this.data.getLocalPrevious();
		if (!prevData.length) return;
		const filtered = prevData.filter(i => i[1]['logged-user']);
		const users = filtered.map(k => [k[0], k[1]['logged-user']] as any);
		const sorted = users.sort((a, b) => Number(b[0].substr(5) - Number(a[0].substr(5))));
		this.previousUsers$.next(sorted);
	}

	replaceUrlParams(url: string): string {
		const params = {
			clinicId: this.user.clinicId,
			userId: this.user.guid
		};

		return Object.keys(params).reduce((acc, i) => {
			return acc.replace(new RegExp(`{${i}}`, 'g'), (params as any)[i]);
		}, url);
	}
}
